import { Box, IconButton, Tooltip } from "@mui/material"
import { InfoOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

interface CasNumbersCellProps {
  casNumbers?: string[] | null
  className?: string
}

export const CasNumbersCell: FC<CasNumbersCellProps> = ({ casNumbers, className }) => {
  const numbers = casNumbers || []

  if (!numbers.length) {
    return null
  }

  if (numbers.length === 1) {
    return <Box className={className}>{numbers[0]}</Box>
  }

  return (
    <Box className={twMerge("flex items-center", className)}>
      Multiple
      <Tooltip
        title={
          <Box>
            {numbers.map((cas) => (
              <Box key={cas}>{cas}</Box>
            ))}
          </Box>
        }
        arrow
        placement='top'
      >
        <IconButton size='small' className='ml-1'>
          <InfoOutlined fontSize='small' />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
